import { Component, EventEmitter, Input, OnDestroy, Output, inject } from '@angular/core';
import { Subject, debounceTime, distinctUntilChanged, filter, take, takeWhile, tap } from 'rxjs';
import { AnimalModel } from 'src/app/modules/animals/models/animal.model';
import { AnimalRepository } from 'src/app/modules/animals/states/animal.repository';

/**
 * Wiederverwendbare Mutter-Auswahl: Input (zeigt die gewählte Mutter) + Such-Modal
 * (Tiersuche per AnimalRepository). Klick aufs Input ODER den Such-Button öffnet das Modal.
 * Der Parent besitzt den State und reagiert auf (motherSelected).
 */
@Component({
  selector: 'app-mother-select',
  templateUrl: './mother-select.component.html',
  standalone: false,
})
export class MotherSelectComponent implements OnDestroy {
  /** Aktuell gewählte Mutter (für die Anzeige im Input). */
  @Input() mother: AnimalModel | null | undefined;
  /** Tier-Id, die aus den Suchergebnissen ausgeschlossen wird (z. B. das eigene Tier). */
  @Input() excludeAnimalId: number | null | undefined = null;
  /** i18n-Key des Labels. */
  @Input() label = 'animalEdit.general.basicData.mother';

  @Output() motherSelected = new EventEmitter<AnimalModel>();

  dialogVisible = false;
  searchTerm = '';
  searchTermChanged = new Subject<string>();
  animalSearchResult: AnimalModel[] = [];

  private alive = true;
  private readonly _animalRepository = inject(AnimalRepository);

  constructor() {
    this.searchTermChanged
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeWhile(() => this.alive),
        tap(term => {
          if (!term || term.length === 0) {
            this.animalSearchResult = [];
          }
        }),
        filter(term => !!term && term.length > 1)
      )
      .subscribe(term => {
        this._animalRepository
          .searchAnimals(term)
          .pipe(take(1))
          .subscribe(results => {
            this.animalSearchResult = (results ?? []).filter(
              animal => animal.id !== this.excludeAnimalId
            );
          });
      });
  }

  openDialog(): void {
    this.searchTerm = '';
    this.animalSearchResult = [];
    this.dialogVisible = true;
  }

  onSearch(): void {
    this.searchTermChanged.next(this.searchTerm);
  }

  selectAnimal(animal: AnimalModel): void {
    this.motherSelected.emit(animal);
    this.dialogVisible = false;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
